import Mapper from '@/models/mappers/Mapper';
import { mapValueToInterface } from '@/utils/models';
import { ProductCategoryOption } from '@/models/entities/ProductCategoryOption';
import { ProductCategoryOptionDTO } from '@/api/dto/ProductCategoryOptionDTO';

export class ProductCategoryOptionMapper extends Mapper<
  ProductCategoryOption,
  ProductCategoryOptionDTO
> {
  mapFromDTO(productCategoryOptionDTO: ProductCategoryOptionDTO): ProductCategoryOption {
    return new ProductCategoryOption(
      <Partial<ProductCategoryOption>>productCategoryOptionDTO,
    );
  }

  mapToDTO(productCategoryOption: ProductCategoryOption): ProductCategoryOptionDTO {
    return mapValueToInterface(productCategoryOption) as ProductCategoryOptionDTO;
  }
}
